import { render, staticRenderFns } from "./FormInternDemo.vue?vue&type=template&id=36b627b9&scoped=true"
import script from "./FormInternDemo.vue?vue&type=script&lang=js"
export * from "./FormInternDemo.vue?vue&type=script&lang=js"
import style0 from "./FormInternDemo.vue?vue&type=style&index=0&id=36b627b9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b627b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b627b9')) {
      api.createRecord('36b627b9', component.options)
    } else {
      api.reload('36b627b9', component.options)
    }
    module.hot.accept("./FormInternDemo.vue?vue&type=template&id=36b627b9&scoped=true", function () {
      api.rerender('36b627b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Form/FormInternDemo.vue"
export default component.exports